module.exports = "img/flags/IL.b71a8cf.png";